import { render, staticRenderFns } from "./RemitFormModal.vue?vue&type=template&id=2c0713da&"
import script from "./RemitFormModal.vue?vue&type=script&lang=js&"
export * from "./RemitFormModal.vue?vue&type=script&lang=js&"
import style0 from "./RemitFormModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports